<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import type {
    ImageStoryblok,
    PostEmbedBlok,
    RichTextBlok,
    TextCardStoryblok,
  } from "$types/components";
  import { getAppContext } from "$lib/utils/contexts";

  export let blok: {
    spaceAround?: string;
    // TODO: this should probably be PostStoryblok['content'][]
    content: (RichTextBlok | ImageStoryblok | PostEmbedBlok | TextCardStoryblok)[];
  };

  const isPostS6 = getAppContext("pageType") === "post-s6";

  function isOtherValidComponent(component: string) {
    return (
      component === "quote" ||
      component === "chapters" ||
      component === "videoVimeo" ||
      component === "videoYoutube" ||
      component === "video"
    );
  }

  function isWrapperlessComponent(component: string) {
    return component === "postTwoCol";
  }

  function getSectionClassName(spaceAround: string, isHeading?: boolean) {
    return spaceAround !== "tight"
      ? "type:body-large"
      : isHeading
        ? "type:body-large-tight"
        : "";
  }
</script>

<div class="post-content">
  <!-- Post Content -->
  {#each blok.content as section}
    {#if section.component === "richText"}
      <div class="post-article ol-step" use:storyblokEditable={section}>
        <StoryblokComponent
          blok={section}
          class={getSectionClassName(
            blok.spaceAround,
            // TODO: the component property of RichTextBlok is a string, so this doesn't
            section?.isHeading,
          )}
        />
      </div>
    {/if}

    {#if section.component === "image"}
      <div
        use:storyblokEditable={section}
      >
        <StoryblokComponent
          blok={section}
          media={section.object}
          caption={section.caption?.[0]}
        />
      </div>
    {/if}

    {#if section.component === "postEmbed"}
      <div class="post-embed aspect-video" use:storyblokEditable={section}>
        {@html section.embed}
      </div>
    {/if}

    {#if section.component === "textCard"}
      <div class="rich-text">
        <StoryblokComponent blok={section} contentClass="type:body-large" />
      </div>
    {/if}

    {#if section.component === "table" || section.component === "faqs"}
      <div>
        <StoryblokComponent blok={section} />
      </div>
    {/if}

    {#if isOtherValidComponent(section.component)}
      <div class="" use:storyblokEditable={section}>
        <StoryblokComponent blok={section} />
      </div>
    {/if}

    {#if isWrapperlessComponent(section.component)}
      <StoryblokComponent blok={section} />
    {/if}
  {/each}

  <!-- Fix for video category posts inner page -->
  {#if blok?.modal?.length > 0 && blok?.modal[0]?.content.length > 0}
    <div class="lg:-mx-24">
      <div class="aspect-video">
        <StoryblokComponent blok={blok?.modal[0]?.content[0]} />
      </div>
    </div>
  {/if}
</div>

<style lang="postcss">
  .post-content {
    color: rgb(var(--color-text-dark-grey));
    @apply space-y-12;

    .aspect-video {
      aspect-ratio: 16/9;
    }
  }
</style>
